<template>
    <div class="accountInfoManagementWarp">
        <div class="infowarp">
            <div class="lefthandlebox">
                <div class="titleBox">账户信息</div>
                <!-- <el-upload id="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="logoSuccess" :on-remove="logoRemove" :action="actionUrl"
                    :headers="header" :limit="1" :file-list="logoList">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload> -->
                <!-- <img :src='headImgUrl' class="headerImg" /> -->
                <div class="username">{{formObj?formObj.userName:''}}</div>
                <div class="companybox">{{formObj?formObj.corpInfoName:''}}</div>
                <div class="grade">{{memberlevel}}</div>
                <div class="savebox" @click="submitForm('ruleForm')" v-if="isedit">
                    <el-button :disabled="isloading" :loading="isloading">信息保存</el-button>
                    <img :src="saveicon" class="iconimg" />
                </div>
                <div class="savebox2" v-else>
                    <!-- <span>信息保存</span>
                    <img :src="saveicon" class="iconimg" /> -->
                    信息审核中
                </div>
            </div>
            <div class="rightformbox">
                <!-- 会员用户 -->
                <el-form :model="ruleForm" :rules="memberRules" ref="ruleForm" label-width="180px" class="demo-ruleForm" v-if="ismember==1">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="用户名" prop="userName">
                                <el-input v-model="ruleForm.userName" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="头像" prop="logo">
                                <el-upload id="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="logoSuccess" :on-remove="logoRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="logoList">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="单位名称" prop="corpInfoName">
                                <el-input v-model="ruleForm.corpInfoName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="曾用名或注册名" prop="oldCorpInfoName">
                                <el-input v-model="ruleForm.oldCorpInfoName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="统一社会信用代码" prop="organizingCord">
                                <el-input v-model="ruleForm.organizingCord"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="入会渠道" prop="channel">
                                <el-select v-model="ruleForm.channel" placeholder="请选择入会渠道" style="width:100%" @change='changeChannel($event)'>
                                    <el-option v-for="item in channelArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="总会会员等级" prop="memberlevel">
                                <el-select v-model="ruleForm.memberlevel" placeholder="请选择总会会员等级" style="width:100%">
                                    <el-option v-for="item in membershipArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-for="(item,
                            index) in ruleForm.branchData" :key="index" shadow="never" v-show="showbranchData" class="branchWarp">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属分会" :prop="'branchData.'+ index +'.branchRegion'" :rules="memberRules.branchRegion">
                                    <el-select v-model="ruleForm.branchData[index].branchRegion" placeholder="请选择所属分会" style="width:100%">
                                        <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="分会会员等级" :prop="'branchData.'+ index +'.memberlevel'" :rules="memberRules.branchmemberlevel">
                                    <el-select v-model="ruleForm.branchData[index].memberlevel" placeholder="请选择所属分会会员等级" style="width:100%" @change="changebranchmemberlevel($event)">
                                        <el-option v-for="item in MemberOrderArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1">
                                <div class="iconbox">
                                    <i class='el-icon-plus' @click="addDomain" />
                                    <i class='el-icon-minus' @click.prevent="removeDomain(item)" />
                                </div>
                            </el-col>
                        </el-row>

                    </div>
                    <!-- <div v-for="(item,
                            index) in ruleForm.branchData" :key="index" shadow="never" v-show="channelId!=0" class="branchWarp">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="所属分会" :prop="'branchData.'+ index +'.branchRegion'" :rules="memberRules.branchRegion">
                                    <el-select v-model="ruleForm.branchData[index].branchRegion" placeholder="请选择所属分会" style="width:100%">
                                        <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="分会会员等级" :prop="'branchData.'+ index +'.memberlevel'" :rules="memberRules.branchmemberlevel">
                                    <el-select v-model="ruleForm.branchData[index].memberlevel" placeholder="请选择所属分会会员等级" style="width:100%" @change="changebranchmemberlevel($event)">
                                        <el-option v-for="item in MemberOrderArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <div class="iconbox">
                            <i class='el-icon-plus' @click="addDomain" />
                            <i class='el-icon-minus' @click.prevent="removeDomain(item)" />
                        </div>
                    </div> -->
                    <!-- <div v-show="channelId!=0" class="branchWarp">
                        <el-row :gutter="20">
                            <el-col :span="12" v-if="channelId!=0">
                                <el-form-item label="所属分会" prop="branchRegion" class="label10">
                                    <el-select v-model="ruleForm.branchRegion" placeholder="请选择所属分会" style="width:100%">
                                        <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                    <el-form-item label="所属分会会员" prop="branchmemberlevel">
                        <el-select v-model="ruleForm.branchmemberlevel" placeholder="请选择所属分会会员等级" style="width:100%" @change="changebranchmemberlevel($event)">
                            <el-option v-for="item in MemberOrderArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>

                    </el-row>
                    <div class="iconbox">

                        <i class='el-icon-plus' />

                        <i class='el-icon-minus' />
                    </div>

                 </div> -->

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-row :gutter="0">
                                <el-form-item label="注册地址" prop='regionalCode'>
                                    <el-col :span="8">
                                        <el-select v-model="ruleForm.city.province" placeholder="请选择省份" @change="onProvinces($event)" style="width:100%">
                                            <el-option v-for="item in ProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-select v-model="ruleForm.city.town" placeholder="请选择市区" style="width:100%" @change="onTowns($event)">
                                            <el-option v-for="item in CityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-select v-model="ruleForm.city.county" placeholder="请选择县" style="width:100%" @change="countyFn($event)">
                                            <el-option v-for="item in CountyArr" :key="item.areaId" :label="item.area" :value="item.area"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-form-item>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-row :gutter="20">
                                <div class="reigstMoney">
                                    <el-form-item label="注册资金" prop="registeredMoney">
                                        <el-input placeholder="请输入" v-model="ruleForm.registeredMoney" class="input-with-select">
                                            <el-select v-model="ruleForm.registeredMoneyType" slot="prepend" placeholder="请选择" style="width:120px">
                                                <el-option v-for="item in currencyArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                            <template slot="append">万元</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-row>
                        </el-col>

                    </el-row>

                    <!-- <el-row :gutter="20">
                        <el-col :span="12">
                            <el-row :gutter="20">
                                <div class="reigstMoney">
                                    <el-form-item label="注册资金" prop="registeredMoney">
                                        <el-input placeholder="请输入" v-model="ruleForm.registeredMoney" class="input-with-select">
                                            <el-select v-model="ruleForm.registeredMoneyType" slot="prepend" placeholder="请选择" style="width:120px">
                                                <el-option v-for="item in currencyArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                                </el-option>
                                            </el-select>
                                            <template slot="append">万元</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="所属分会" prop="branchRegion">
                                <el-select v-model="ruleForm.branchRegion" placeholder="请选择所属分会" style="width:100%">
                                    <el-option v-for="item in branchProvinceArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                    <!-- <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="法定代表人" prop="legalPersonName">
                                <el-input v-model="ruleForm.legalPersonName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="" prop="branchmemberlevel">
                                <el-select v-model="ruleForm.branchmemberlevel" placeholder="请选择所属分会会员等级" style="width:100%" @change="changebranchmemberlevel($event)">
                                    <el-option v-for="item in MemberOrderArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row> -->

                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="单位规模" prop="corpScale">
                                <el-select v-model="ruleForm.corpScale" placeholder="请选择单位规模" style="width:100%">
                                    <el-option v-for="item in UnitSizeArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位类型" prop="organizingCordType">
                                <el-select v-model="ruleForm.organizingCordType" placeholder="请选择单位类型" style="width:100%">
                                    <el-option v-for="item in organizingCordTypeArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="法定代表人" prop="legalPersonName">
                                <el-input v-model="ruleForm.legalPersonName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="成立日期" prop="registeredTime">
                                <el-date-picker v-model="ruleForm.registeredTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"
                                    style="width:100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">

                            <el-form-item label="主营业务" prop="mainBusiness">
                                <el-select v-model="ruleForm.mainBusiness" placeholder="请选择主营业务" style="width:100%" multiple>
                                    <el-option v-for="item in mainBusinessArr" :key="item.dictionariesId" :label="item.dictMsg" :value="item.dictionariesId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="上市公司 " prop="isListedCorp">
                                <el-radio-group v-model="ruleForm.isListedCorp">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>

                        <!-- <el-col :span="12">
                            <el-form-item label="传真" prop="fox">
                                <el-input v-model="ruleForm.fox"></el-input>
                            </el-form-item>
                        </el-col> -->
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="通讯地址" prop="currentSite">
                                <el-input v-model="ruleForm.currentSite"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <div class="acceptMailBox">
                                <el-form-item label="全国性社会团体会费统一票据接收邮箱" prop="acceptMail">
                                    <el-input v-model="ruleForm.acceptMail"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="邮编" prop="postalCord">
                                <el-input v-model="ruleForm.postalCord"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单位网址" prop="website">
                                <el-input v-model="ruleForm.website"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="单位简介" prop="remark">
                                <el-input type="textarea" :rows="4" placeholder="请输入内容" minlength='300' show-word-limit maxlength="1000" v-model="ruleForm.remark">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <!-- class="label10" -->
                            <el-form-item label="入会申请书" prop="application">
                                <img v-if="ruleForm.application" class="applicationimg" :src="srcUrl+ruleForm.application" />
                                <el-upload v-else accept=".jpg,.png,.jpeg" id="appupload" list-type="picture-card" :on-success="handleAvatarSuccess" :on-remove="handleRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="营业执照\法人登记证书" prop="materials1" class="label10">
                                <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="secondSuccessFn" :on-remove="secondRemoveFn" :action="actionUrl"
                                    :headers="header" :file-list="secondfileList">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="人力资源服务相关许可证" prop="materials2">
                                <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="thirdSuccessFn" :on-remove="thirdRemoveFn" :action="actionUrl"
                                    :headers="header" :file-list="thirdfileList">
                                    <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <!-- <div v-show="!isunfold">
                        <el-divider>
                            <div class="unfoldbox" @click="unfoldFn">
                                <img :src="unfoldicon" />
                                <span>展开</span>
                            </div>
                        </el-divider>
                    </div> -->
                    <!-- <div class="hiddenform" ref='hiddenform'> -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人姓名" prop="linkName.linkName">
                                <el-input v-model="ruleForm.linkName.linkName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <!-- :disabled="true" -->
                            <el-form-item label="联系人手机号码" prop="linkName.phone">
                                <el-input v-model="ruleForm.linkName.phone" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人职务" prop="linkName.contactPost">
                                <el-input v-model="ruleForm.linkName.contactPost"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人邮箱" prop="linkName.email">
                                <el-input v-model="ruleForm.linkName.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人身份证号码" prop="linkName.cardCode">
                                <el-input v-model="ruleForm.linkName.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人办公电话" prop="linkName.officePhone">
                                <el-input v-model="ruleForm.linkName.officePhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="联系人微信号" prop="linkName.weChat">
                                <el-input v-model="ruleForm.linkName.weChat"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人姓名" prop="principal.linkName">
                                <el-input v-model="ruleForm.principal.linkName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人手机号码" prop="principal.phone">
                                <el-input v-model="ruleForm.principal.phone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人职务" prop="principal.contactPost">
                                <el-input v-model="ruleForm.principal.contactPost"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人邮箱" prop="principal.email">
                                <el-input v-model="ruleForm.principal.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人身份证号码" prop="principal.cardCode">
                                <el-input v-model="ruleForm.principal.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="负责人办公电话" prop="principal.officePhone">
                                <el-input v-model="ruleForm.principal.officePhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="负责人微信号" prop="principal.weChat">
                                <el-input v-model="ruleForm.principal.weChat"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="备注" prop="postscript">
                                <!-- minlength='300' show-word-limit maxlength="1000" -->
                                <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="ruleForm.postscript">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- </div>
                    <div v-show="isunfold">
                        <el-divider>
                            <div class="unfoldbox" @click="packupFn">
                                <img :src="packupicon" />
                                <span>收起</span>
                            </div>
                        </el-divider>
                    </div> -->
                </el-form>
                <!-- 非会员用户 -->
                <el-form :model="nomemberForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-else>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="头像" prop="logo">
                                <el-upload id="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="logoSuccess" :on-remove="logoRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="logoList">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="用户名" prop="userName">
                                <el-input v-model="nomemberForm.userName" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="linkName">
                                <el-input v-model="nomemberForm.linkName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="身份证号" prop="cardCode">
                                <el-input v-model="nomemberForm.cardCode"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="手机号码" prop="phone">
                                <el-input v-model="nomemberForm.phone" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="微信号" prop="weChat">
                                <el-input v-model="nomemberForm.weChat"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="单位名称" prop="corpInfoName">
                                <el-input v-model="nomemberForm.corpInfoName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">

                        <el-col :span="12">
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="nomemberForm.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

        </div>
        <!-- 没有联系人手机号 -->
        <el-dialog title="" :visible.sync="dialogVisible" width="720px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'>
            <div class="dialogcenterbox">
                <div class="text1">您好，修改账户信息需获取您的手机号码(正确格式的手机号码)</div>
                <div class="text2">请前往其他页面填写，是否立即前往？</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="okFn">立即前往</el-button>
                <el-button @click="cancelFn">暂不</el-button>
            </span>
        </el-dialog>
        <!-- 绑定微信 -->
        <!-- <el-dialog title="" :visible.sync="codeVisible" width="480px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'
		    :close="offloginVisible">
			<div class="codeBox">
				<div id="wxcode">
				</div>
			</div>
		</el-dialog> -->
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
export default {
    components: {
    },
    data() {
        var validatePhone = (rule, value, callback) => {
            let reg = /^1[3|4|5|7|8][0-9]\d{8}$/
            // er: 'blur', required: true },
            //         { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }
            if (value === '') {
                callback(new Error('请输入联系人手机号码'));
            } else if (!reg.test(value)) {
                callback(new Error('手机号码格式不正确'));
                this.dialogVisible = true
            } else {
                callback();
            }
        };
        return {
            srcUrl: srcUrl,
            headImgUrl: require("@/assets/imgs/account/header.png"),
            saveicon: require("@/assets/imgs/account/icon9.png"),
            unfoldicon: require("@/assets/imgs/account/unfold.png"),
            packupicon: require("@/assets/imgs/account/packup.png"),
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            isloading: false,
            nomemberForm: {
                logo: '',
                userName: '',
                linkName: '',
                cardCode: '',
                phone: '',
                email: '',
                weChat: '',
                corpInfoName: '',
            },
            ruleForm: {
                postscript: '',
                oldCorpInfoName: '',
                acceptMail: '',
                logo: '',
                userName: '',
                channel: '',
                corpInfoName: '',
                branchData: [
                    {
                        branchRegion: '',
                        memberlevel: '',
                    }
                ],
                organizingCord: '',
                memberlevel: '',//总会会员等级
                registeredMoney: '',
                regionalCode: '',
                city: { // 三级联动
                    province: '',
                    town: '',
                    county: ''
                },
                corpScale: '',
                legalPersonName: '',
                organizingCordType: '',//单位类型
                registeredTime: '',//成立日期
                isListedCorp: '',
                mainBusiness: [],//主要业务
                website: '',
                currentSite: '',
                postalCord: '',
                fox: '',
                remark: '',
                linkName: {
                    linkName: '',
                    cardCode: '',
                    contactPost: '',
                    officePhone: '',
                    phone: '',
                    weChat: '',
                    email: ''
                },
                principal: {
                    linkName: '',
                    cardCode: '',
                    contactPost: '',
                    officePhone: '',
                    phone: '',
                    weChat: '',
                    email: ''
                },
                branchData: [{
                    //  分支机构
                    branchRegion: '',
                    //  分会等级
                    memberlevel: ''
                }],
                registeredMoneyType: '212',//默认资金类型
                // 上传的图片
                application: '',
                materials1: '',
                materials2: '',
            },
            memberForm: {
                imageUrl: ''
            },
            options: [{
                value: '人民币',
                label: '人民币'
            }, {
                value: '美元',
                label: '美元'
            }],
            rules: {
                // 非会员
                userName: [
                    { required: true, message: '请输入用户名,用户名建议以"拼音+数字"组合', trigger: 'blur' },
                ],
                linkName: [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入联系人手机号码', trigger: 'blur', },
                    { validator: validatePhone, trigger: 'blur', required: true },
                    // { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }

                ],
                email: [
                    // { pattern: /\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}/, message: '请输入正确的联系人邮箱', trigger: 'blur' }
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                corpInfoName: [
                    { required: true, message: '请输入单位名称', trigger: 'blur' },
                ],
                cardCode: [
                    { message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
            },
            memberRules: {
                acceptMail: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                channel: [
                    { required: true, message: '请选择入会渠道', trigger: 'change' }
                ],
                corpInfoName: [
                    { required: true, message: '请输入单位名称', trigger: 'blur' },
                ],
                branchRegion: [
                    { required: true, message: '请选择所属分会' }
                ],
                branchmemberlevel: [
                    { required: true, message: '请选择所属分会会员等级' }
                ],
                organizingCord: [
                    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
                ],
                regionalCode: [
                    { required: true, message: '请选择注册地址', trigger: 'change' }
                ],
                memberlevel: [
                    { required: true, message: '请选择总会会员等级', trigger: 'change' }
                ],
                registeredMoney: [
                    { required: true, message: '请输入注册资金', trigger: 'blur' },
                ],
                corpScale: [
                    { required: true, message: '请选择单位规模', trigger: 'change' }
                ],
                legalPersonName: [
                    { required: true, message: '请输入法定代表人', trigger: 'blur' },
                ],
                organizingCordType: [
                    { required: true, message: '请选择单位类型', trigger: 'change' }
                ],
                isListedCorp: [
                    { required: true, message: '请选择是否上市公司 ', trigger: 'change' }
                ],
                mainBusiness: [
                    { required: true, message: '请选择主营业务 ', trigger: 'change' }
                ],
                currentSite: [
                    { required: true, message: '请输入通讯地址', trigger: 'blur' },
                ],
                postalCord: [
                    { required: true, message: '请输入邮编', trigger: 'blur' },
                ],
                remark: [
                    { required: true, message: '请输入单位简介', trigger: 'blur' },
                    { min: 300, max: 1500, message: '请控制在300-1000个字符以内', trigger: 'blur' }
                ],
                "linkName.linkName": [
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' },
                ],
                "linkName.phone": [
                    { required: true, message: '请输入联系人手机号码', trigger: 'blur', },
                    { validator: validatePhone, trigger: 'blur', required: true },
                    // { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }

                ],
                "linkName.email": [
                    { required: true, message: '请输入联系人邮箱', trigger: 'blur', },
                    // { pattern: /\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}/, message: '请输入正确的联系人邮箱', trigger: 'blur' }
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                'linkName.cardCode': [
                    { message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                'principal.cardCode': [
                    { message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                'principal.email': [
                    // { pattern: /\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}/, message: '请输入正确的邮箱地址', trigger: 'blur' }
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
            },
            ismember: '',//是否会员
            // 展开收起状态
            isunfold: false,
            userId: '',
            MemberOrderArr: [],//分会会员等级
            organizingCordTypeArr: [],//组织机构类型
            mainBusinessArr: [],//主营业务
            branchProvinceArr: [],//所属分支机构
            UnitSizeArr: [],//单位规模
            channelArr: [],//入会渠道
            membershipArr: [],//总会会员等级 -默认普通会员
            ProvinceArr: [],//省
            CityArr: [],//市
            CountyArr: [],//县
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            header: null,
            // 图片数组
            logoList: [],
            imgfileList: [],
            secondfileList: [],
            thirdfileList: [],
            formObj: null,
            memberlevel: '',//会员等级
            currencyArr: [],//币种
            isedit: null,//是否修改
            channelId: '',
            dialogVisible: false,
            showbranchData: true
        }
    },
    created() {
        if (JSON.parse(sessionStorage.getItem('userInfo'))) {
            this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
        } else {
            this.userId = sessionStorage.getItem('nologinuserId')
        }
        // 会员状态
        this.getAuditFn()
        // 数据字典
        this.dataDictionaryFn()

    },
    mounted() {
        this.$nextTick(() => {
            // 回显表单信息
            this.getmemberInfoFn()
        })
        // 获取省的数据
        this.getProvinceFn()
        // 判断是否能修改
        this.getisEditFn()
    },
    methods: {

        getisEditFn() {
            httpService.isInfoaudit().then(res => {
                if (res.code == 200) {
                    this.isedit = res.result
                }
            })
        },
        getAuditFn() {
            httpService.getCorpInfoOther(this.userId).then(res => {
                // 99保存 0提交审核中 1通过 2审核失败
                if (res.code == 200) {
                    this.ismember = res.result.audit
                }
            })
        },
        // 获取数据字典字段数据
        dataDictionaryFn() {
            // 分会会员等级
            let p1 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'branchLevel' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 组织机构类型
            let p2 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'organizingCordType' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 主营业务
            let p3 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'mainBusiness' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 所属分支机构
            let p4 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'branchRegion' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 单位规模UnitSizeArr corpScale
            let p5 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'corpScale' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 入会渠道
            let p6 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'channel' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 总会等级
            let p7 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'membership' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 币种
            let p8 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'currency' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })

            Promise.all([p1, p2, p3, p4, p5, p6, p7, p8]).then(res => {
                if (res) {
                    this.MemberOrderArr = res[0].result;//分会会员等级
                    this.organizingCordTypeArr = res[1].result;//组织机构类型
                    this.mainBusinessArr = res[2].result;//主营业务
                    this.branchProvinceArr = res[3].result;//所属分支机构
                    this.UnitSizeArr = res[4].result;//单位规模
                    this.channelArr = res[5].result;//入会渠道
                    this.membershipArr = res[6].result;//总会会员等级 -默认普通会员
                    this.currencyArr = res[7].result;//总会会员等级 -默认普通会员
                    // 会员等级回显
                    this.membershipArr.map(item => {
                        if (item.dictionariesId == this.ruleForm.memberlevel) {
                            this.memberlevel = item.dictMsg
                        }
                    })

                }
            })
        },
        // 省市县
        getProvinceFn() {
            httpService.getProvince().then(res => {
                if (res.code == 200) {
                    this.ProvinceArr = res.result
                }
            })
        },
        // 选择省
        onProvinces(event) {
            let provinceId
            this.ProvinceArr.map(item => {
                if (event === item.province) {
                    return provinceId = item.provinceId
                }
            })
            // 改变省之后市变化
            this.ruleForm.city.town = '';
            this.ruleForm.city.county = '';
            this.getCityData(provinceId)
        },
        // 获取市
        getCityData(provinceId) {
            httpService.getCity(provinceId).then(res => {
                if (res.code == 200) {
                    this.CityArr = res.result
                    // 回显地址
                    if (this.ruleForm.city.county) {
                        let cityId
                        this.CityArr.map(item => {
                            if (item.city === this.ruleForm.city.town) {
                                return cityId = item.cityId
                            }
                        })
                        this.getCountyData(cityId)
                    }
                }
            })
        },
        // 选择市
        onTowns(event) {
            let cityId
            this.CityArr.map(item => {
                if (event === item.city) {
                    return cityId = item.cityId
                }
            })
            this.ruleForm.city.county = '';
            this.getCountyData(cityId)
        },
        getCountyData(cityId) {
            httpService.getArea(cityId).then(res => {
                if (res.code == 200) {
                    this.CountyArr = res.result
                }
            })
        },
        // 选择区
        countyFn(event) {
            this.ruleForm.city.county = event
            this.$forceUpdate()
            this.ruleForm.regionalCode = `${this.ruleForm.city.province},${this.ruleForm.city.town},${this.ruleForm.city.county}`
        },
        // 回显表单
        // 表单回显
        getmemberInfoFn() {
            httpService.getmemberInfo(this.userId).then(res => {
                if (res.code == 200) {
                    // if (!res.result.linkName) {
                    //     this.dialogVisible = true
                    // } else {
                    //     if (!res.result.linkName.phone) {
                    //          this.dialogVisible = true
                    //     }else{

                    if (this.ismember == 1) {
                        // 原始数据传给上传组件
                        this.formObj = res.result
                        // 还原地址和分支机构
                        res.result.city = {
                            province: '',
                            town: '',
                            county: ''
                        }
                        if (res.result.branchData.length == 0) {
                            this.showbranchData = false
                            res.result.branchData = [
                                {
                                    branchRegion: '',
                                    memberlevel: '',
                                }
                            ]
                        }

                        // if (res.result.branchData.length != 0) {
                        //     res.result.branchRegion = res.result.branchData[0].branchRegion
                        //     res.result.branchmemberlevel = res.result.branchData[0].memberlevel
                        // } else {
                        //     res.result.branchRegion = '';
                        //     res.result.branchmemberlevel = ''
                        // }
                        if (res.result.regionalCode) {
                            res.result.regionalCode = res.result.regionalCode.split(',')
                            res.result.city.province = res.result.regionalCode[0]
                            res.result.city.town = res.result.regionalCode[1]
                            res.result.city.county = res.result.regionalCode[2]
                        } else {
                            res.result.city.province = ''
                            res.result.city.town = ''
                            res.result.city.county = ''
                        }
                        if (!res.result.registeredMoneyType) {
                            res.result.registeredMoneyType = '212'
                        }

                        // 图片处理
                        let logolist = [], imglist = [], materialslist1 = [], materialslist2 = [];
                        if (res.result.logo) {
                            logolist = res.result.logo.split(',');
                            logolist = logolist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                        }
                        if (res.result.application) {
                            imglist = res.result.application.split(',');
                            imglist = imglist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                        }
                        if (res.result.materials1) {
                            materialslist1 = res.result.materials1.split(',');
                            materialslist1 = materialslist1.map((Src, index) => {
                                return {
                                    url: srcUrl + Src,
                                    uid: index,
                                    name: Src
                                };
                            });
                        }
                        if (res.result.materials2) {
                            materialslist2 = res.result.materials2.split(',');
                            materialslist2 = materialslist2.map((Src, index) => {
                                return {
                                    url: srcUrl + Src,
                                    uid: index,
                                    name: Src
                                };
                            });
                        }

                        this.logoList = logolist;
                        this.imgfileList = imglist;
                        this.secondfileList = materialslist1;
                        this.thirdfileList = materialslist2;
                        if (!res.result.linkName) {
                            this.dialogVisible = true
                            res.result.linkName = {
                                linkName: '',
                                cardCode: '',
                                contactPost: '',
                                officePhone: '',
                                phone: '',
                                weChat: '',
                                email: ''
                            }
                        } else {
                            if (!res.result.linkName.phone) {
                                this.dialogVisible = true
                            }
                        }
                        if (!res.result.principal) {
                            res.result.principal = {
                                linkName: '',
                                cardCode: '',
                                contactPost: '',
                                officePhone: '',
                                phone: '',
                                weChat: '',
                                email: ''
                            }
                        }
                        this.ruleForm = res.result
                        if (this.ruleForm.mainBusiness) {
                            this.ruleForm.mainBusiness = this.ruleForm.mainBusiness.split(',')
                        } else {
                            this.ruleForm.mainBusiness = []
                        }
                        this.channelId = res.result.channel
                        if (this.ruleForm.city.town) {
                            let provinceId
                            this.ProvinceArr.map(item => {
                                if (item.province === this.ruleForm.city.province) {
                                    return provinceId = item.provinceId
                                }
                            })
                            this.getCityData(provinceId)
                        }
                        // 头像如果有图片隐藏上传按钮
                        // setTimeout(() => {
                        //     if (this.logoList.length > 0) {
                        //         document.querySelector('.el-upload--picture-card').style.display = 'none'
                        //     }
                        // }, 500);
                        this.$nextTick(() => {
                            this.ruleForm = res.result
                            this.$refs["ruleForm"].clearValidate()
                            if (this.logoList.length > 0) {
                                document.querySelector('.el-upload--picture-card').style.display = 'none'
                            }
                        })
                    } else {
                        // 原始数据传给上传组件
                        this.formObj = res.result
                        // 图片处理
                        let logolist = []
                        if (res.result.logo) {
                            logolist = res.result.logo.split(',');
                            logolist = logolist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                        }
                        this.logoList = logolist;
                        // if (res.result) {
                        //     this.nomemberForm.userName = res.result.userName,
                        //         this.nomemberForm.corpInfoName = res.result.corpInfoName,
                        //         this.nomemberForm.corpInfoId = res.result.corpInfoId
                        // }
                        if (res.result.linkName) {
                            this.nomemberForm = {
                                userName: res.result.userName,
                                corpInfoName: res.result.corpInfoName,
                                corpInfoId: res.result.corpInfoId,
                                linkName: res.result.linkName.linkName,
                                cardCode: res.result.linkName.cardCode,
                                phone: res.result.linkName.phone,
                                email: res.result.linkName.email,
                                weChat: res.result.linkName.weChat

                            }
                            if (!res.result.linkName.phone) {
                                this.dialogVisible = true
                            }
                        } else {
                            this.dialogVisible = true
                        }
                        // 头像如果有图片隐藏上传按钮
                        this.$nextTick(() => {
                            // console.log(this.$refs["ruleForm"]);
                            this.$refs["ruleForm"].clearValidate()
                            if (this.logoList.length > 0) {
                                document.querySelector('.el-upload--picture-card').style.display = 'none'
                            }
                        })
                    }
                    //         }
                    //     }
                }

            })
        },
        okFn() {
            this.dialogVisible = false;
            this.$router.push({
                path: '/retrieve-phone',
            })
        },
        cancelFn() {
            this.dialogVisible = false;
        },
        // 新增分支机构
        addDomain() {
            this.ruleForm.branchData.push({
                branchRegion: '',
                memberlevel: '',
            });
        },
        // 刪除分支機構
        removeDomain(item) {
            var index = this.ruleForm.branchData.indexOf(item)
            if (this.channelId != 0 && index == 0) {
                this.$message({
                    message: '当前入会渠道为分支机构，至少保留一条分会数据',
                    type: 'warning'

                });
                return
            }
            if (index !== -1) {
                this.ruleForm.branchData.splice(index, 1)
            }
        },
        submitForm(formName) {
             
            if (this.channelId == 0) {
                // delete validateObj.branchRegion
                // delete validateObj.branchmemberlevel
                this.memberRules.branchRegion[0].required = false
                this.memberRules.branchmemberlevel[0].required = false
            } else {
                this.memberRules.branchRegion[0].required = true
                this.memberRules.branchmemberlevel[0].required = true
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                   this.isloading = true
                    // 会员
                    if (this.ismember == 1) {
                        // this.ruleForm.mainBusiness=this.ruleForm.mainBusiness.join(',')
                        if (this.ruleForm.mainBusiness instanceof Array) {
                            this.ruleForm.mainBusiness = this.ruleForm.mainBusiness.join(',')
                        }
                        if (Array.isArray(this.ruleForm.regionalCode)) {
                            this.ruleForm.regionalCode = this.ruleForm.regionalCode.join(',')
                        }
                        let applyDataUrl1 = [], applyDataUrl2 = [], logo, application
                        if (this.imgfileList.length != 0) {
                            this.imgfileList.forEach(item => {
                                if (item.response) {
                                    return application = item.response.result
                                } else {
                                    return application = item.name
                                }
                            })
                        }
                        if (this.logoList.length != 0) {
                            this.logoList.forEach(item => {
                                if (item.response) {
                                    return logo = item.response.result
                                } else {
                                    return logo = item.name
                                }
                            })
                        }
                        if (this.secondfileList.length != 0) {
                            this.secondfileList.map(item => {
                                if (item.response) {
                                    return applyDataUrl1.push(item.response.result)
                                } else {
                                    return applyDataUrl1.push(item.name)
                                }
                            })
                        }
                        if (this.thirdfileList.length != 0) {
                            this.thirdfileList.map(item => {
                                if (item.response) {
                                    return applyDataUrl2.push(item.response.result)
                                } else {
                                    return applyDataUrl2.push(item.name)
                                }
                            })
                            this.ruleForm.materials2 = applyDataUrl2.join(',')
                        } else {
                            this.ruleForm.materials2 = null
                        }
                        this.ruleForm.logo = logo
                        this.ruleForm.materials1 = applyDataUrl1.join(',')
                        this.ruleForm.application = application
                        // this.channelId == 0
                        if (this.ruleForm.branchData.length == 0) {
                            this.ruleForm.branchData = null
                        }
                        // else {
                        //     this.ruleForm.branchData = [{
                        //         //  分支机构
                        //         branchRegion: this.ruleForm.branchRegion,
                        //         //  分会等级
                        //         memberlevel: this.ruleForm.branchmemberlevel
                        //     }]
                        // }
                        // this.ruleForm.audit = 99,//保存
                        httpService.updateUserInfo(this.ruleForm).then(res => {
                            if (res) {
                                this.isloading = false
                                if (res.code == 200) {
                                    this.$message({
                                        message: '信息修改成功',
                                        type: 'success'
                                    });
                                    this.getmemberInfoFn()
                                    this.getisEditFn()
                                } else {
                                    this.$message.error(res.message);
                                }
                            }
                        })
                    }
                    // 非会员
                    else {
                        let logo
                        if (this.logoList.length != 0) {
                            this.logoList.forEach(item => {
                                if (item.response) {
                                    return logo = item.response.result
                                } else {
                                    return logo = item.name
                                }
                            })
                        }
                        this.nomemberForm.logo = logo
                        this.nomemberForm.userId = this.userId
                        httpService.updateInfoforCorpInfo(this.nomemberForm).then(res => {

                            if (res) {
                                this.isloading = false
                                if (res.code == 200) {
                                    this.$message({
                                        message: '信息修改成功',
                                        type: 'success'
                                    });
                                    this.getmemberInfoFn()
                                    this.getisEditFn()
                                } else {
                                    this.$message.error(res.message);
                                }
                            }
                        })

                    }
                } else {
                    this.$nextTick(() => {
                        formErrorScroll()
                    })
                    return false;
                }
            });
        },
        // 图片上传相关
        // 头像上传
        logoSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.logoList = fileList
                // this.ruleForm.logo=res.result
                if (this.logoList.length > 0) {
                    document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        logoRemove() {
            this.logoList = []
            if (this.logoList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 图片上传
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.imgfileList = fileList
                // this.ruleForm.titleImgUrl = res.result
                if (this.imgfileList.length > 0) {
                    document.querySelector('#appupload').firstChild.nextSibling.style.display = 'none'
                    // imgupload
                }
            }
            // this.imageUrl = URL.createObjectURL(file.raw);
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#appupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 第二个上传
        secondSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.secondfileList = fileList
            }
        },
        secondRemoveFn(file, fileList) {
            this.secondfileList = fileList
        },
        // 第三个上传
        thirdSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.thirdfileList = fileList
            }
        },
        thirdRemoveFn(file, fileList) {
            this.thirdfileList = fileList
        },
        // 展开收起
        unfoldFn() {
            this.$refs.hiddenform.style.height = '500px'
            this.isunfold = true
        },
        packupFn() {
            this.$refs.hiddenform.style.height = '0px'
            this.$refs.hiddenform.addEventListener("transitionend", () => {
                this.isunfold = false
            }, true);
        },
        // 入会渠道
        // 选择的入会渠道
        changeChannel(event) {
            // 0时是总会
            // if (event==0) {
            //     this.channelId='总会'
            // }
            this.channelId = event
            this.ruleForm.branchmemberlevel = '';
            this.ruleForm.branchRegion = '';
            let channelName
            this.channelArr.map(item => {
                if (item.dictionariesId == event) {
                    return channelName = item.dictMsg
                }
            })
            if (this.channelId != 0) {
                this.branchProvinceArr.forEach(item => {
                    if (item.dictMsg == channelName) {
                        this.ruleForm.branchRegion = item.dictionariesId
                        this.branchLabel = item.dictMsg
                    }
                })
            } else {
                this.disabled = true
            }
        },
        changebranchmemberlevel(event) {
            this.$forceUpdate()
            this.$nextTick(() => {
                // DOM 更新了
                this.$refs["ruleForm"].clearValidate()
            })
        },

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.accountInfoManagementWarp {
	width: 100%;
	box-sizing: border-box;
	padding: 20px 0 0 20px;
	.titleBox {
		font-size: 24px;
		font-weight: bold;
		line-height: 24px;
		color: #43424b;
		margin-bottom: 32px;
	}
	.acceptMailBox {
		/deep/.el-form-item__label {
			line-height: 20px;
		}
	}
	.infowarp {
		display: flex;
		flex-direction: row;
		.lefthandlebox {
			display: flex;
			flex-direction: column;
			width: 200px;
			align-items: center;
			// justify-content: center;
			// .headerImg {
			// 	width: 80px;
			// 	height: 78px;
			// }
			/deep/.el-upload--picture-card {
				background-color: #fbfdff;
				border: 1px dashed #c0ccda;
				border-radius: 6px;
				box-sizing: border-box;
				width: 80px;
				height: 80px;
				line-height: 86px;
				vertical-align: top;
				border-radius: 50%;
			}
			/deep/.el-upload-list--picture-card .el-upload-list__item {
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}

			.username {
				font-size: 20px;
				font-weight: bold;
				line-height: 31px;
				color: #43424b;
				margin-top: 10px;
			}
			.companybox,
			.grade {
				font-size: 16px;
				line-height: 20px;
				color: #a6a9b7;
				margin-top: 10px;
			}
			.savebox {
				width: 152px;
				height: 49px;
				background: linear-gradient(101deg, #00c6ff 0%, #0072ff 100%);
				font-size: 16px;
				font-weight: 500;
				line-height: 49px;
				color: #ffffff;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 32px;
				cursor: pointer;
				.iconimg {
					width: 15px;
					height: 16px;
					align-items: center;
					margin-left: 13px;
				}
				.el-button {
					background: transparent;
					border: none;
					color: #fff;
					font-size: 16px;
					font-weight: 500;
					padding: 0;
				}
			}
			.savebox2 {
				width: 152px;
				height: 49px;
				background: #ccc;
				font-size: 16px;
				font-weight: 500;
				line-height: 49px;
				color: #ffffff;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 32px;
				cursor: not-allowed;
				.iconimg {
					width: 15px;
					height: 16px;
					align-items: center;
					margin-left: 13px;
				}
				.el-button.is-loading:before {
					background-color: transparent;
				}
				.is-loading:before {
					background-color: transparent;
				}
			}
		}
		.rightformbox {
			width: 1100px;
			.label10 {
				/deep/.el-form-item__label {
					padding-left: 12px;

					position: relative;
					&::before {
						// position: absolute;
						top: 12px;
						left: 0px;
						// margin-right: 4px;
						color: #ff4d4f;
						font-size: 16px;
						font-family: SimSun, sans-serif;
						line-height: 1;
						content: '*';
					}
				}
			}

			.reigstMoney {
				display: flex;
				flex-direction: row;
				margin-left: 10px;
				width: 96.2%;
			}
			.hiddenform {
				height: 0;
				overflow: hidden;
				transition: all 2s;
			}
			.unfoldbox {
				cursor: pointer;
				display: flex;
				flex-direction: column;
				font-size: 16px;
				line-height: 24px;
				color: #cfd0d6;

				img {
					width: 32px;
					height: 21px;
				}
			}
			/deep/.el-upload--picture-card {
				background-color: #fbfdff;
				border: 1px dashed #c0ccda;
				border-radius: 6px;
				box-sizing: border-box;
				width: 80px;
				height: 80px;
				line-height: 86px;
				vertical-align: top;
			}
			.applicationimg {
				width: 80px;
				height: 80px;
			}
			/deep/.el-upload-list--picture-card .el-upload-list__item {
				width: 80px;
				height: 80px;
			}
			.branchWarp {
				position: relative;
				// display: flex;
				// flex-direction: row;
				// align-items: center;
				.iconbox {
					cursor: pointer;
					// position: absolute;
					// right: -50px;
					// top: 6px;
					font-size: 21px;
					font-weight: bold;
					color: #6ed3ac;
                    padding-top: 6px;
				}
			}
		}
	}
	/deep/.el-textarea .el-input__count {
		background: transparent;
		bottom: -28px;
	}
	/deep/.dialogcenterbox {
		padding: 0px 0 90px 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		.text1 {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin: 46px 0;
		}
		.text2 {
			font-size: 16px;
			line-height: 30px;
			color: #666666;
		}
	}
}
</style>


